import { Box, Button, Typography } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import * as React from "react";
import Tab from "@mui/material/Tab";
import { useEffect } from "react";
import back from "../../../public/assets/icons/back.svg";

type Props = {
  queueProfile?: any;
  coderDistribution?: any;
  caseSamples?: any;
  cqaSamples?: any;

  directoryType?: any;
  setDirectoryType?: any;

  entryId?: any;
  setEntryId?: any;

  setShowDetails?: any;
  showDetails?: any;

  isQA?: boolean;
  isQualityAssessment?: boolean;

  tabs?: Array<{ label: string; value: string}>;
};

const isQaSamples = (directoryType: string) => ["case_samples", "coder_samples", "verification_samples"].includes(directoryType);
const isCqaSamples = (directoryType: string) => directoryType === "cqa_samples";

export const CollectionsDashboard = (props: Props) => {
  const { showDetails, setShowDetails, directoryType, setDirectoryType } = props;
  const {tabs} = props;
  const [value, setValue] = React.useState("case_samples");

  useEffect(() => {
    if (!directoryType?.length) {
      setDirectoryType(props?.isQA ? "coder_samples" : "collection");
      setValue(props?.isQA ? "coder_samples" : "collection");
    }
    else if(props?.isQualityAssessment) {
        setDirectoryType("cqa_samples");
        setValue("cqa_samples");
    }
  }, []);

  const handleChange = (
    event: React.SyntheticEvent<Element, Event>,
    newValue: string
  ) => {
    setValue(newValue);
    setDirectoryType(newValue);
  };

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "white",
        boxShadow: "0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)",
      }}
    >
      <>
        <Box sx={{ width: "100%" }}>
          <>
            <Box sx={{ marginLeft: "20px", marginRight: "20px" }}>
              {showDetails ? (
                <Box sx={{ marginRight: "40px" }}>
                  <Box
                    sx={{ marginBottom: "10px", marginTop: "10px" }}
                    onClick={() => {
                      setShowDetails(false);
                    }}
                  >
                    <Button startIcon={<img src={back} alt="back" />}>
                      <Typography
                        variant="caption1"
                        color="artisticTextInteractive.main"
                      >
                        Back to page
                      </Typography>
                    </Button>
                  </Box>
                  {value === "collection" && <props.queueProfile />}
                  {isQaSamples(props.directoryType) && <props.caseSamples />}
                  {isCqaSamples(props.directoryType) && <props.cqaSamples />}
                </Box>
              ) : (
                <TabContext value={value}>

                  {(tabs && tabs.length > 0) && (
                    <Box
                      sx={{
                        display: "flex",
                        borderBottom: "1px solid lightgray",
                      }}
                    >
                      <TabList variant="scrollable" onChange={handleChange}>
                        {tabs?.map((tab, key) => (
                          <Tab
                            style={{ minWidth: "76px" }}
                            label={
                              <Typography variant="body1">{tab.label}</Typography>
                            }
                            value={tab.value}
                            onClick={() => {
                              if (props?.showDetails) {
                                props?.setShowDetails(false);
                              }
                              props?.setDirectoryType(tab.value);
                            }}
                            key={key}
                          />
                        ))}
                      </TabList>
                    </Box>
                  )}

                  {value === "collection" && (
                    <TabPanel
                      sx={{ padding: 0 }}
                      value={value}
                    >
                      <props.queueProfile />
                    </TabPanel>
                  )}
                  {value === "distribution" && (
                    <TabPanel
                      sx={{ padding: 0 }}
                      value={value}
                    >
                      <props.coderDistribution />
                    </TabPanel>
                  )}
                  {value === "case_samples" && props.caseSamples && (
                    <TabPanel
                      sx={{ padding: 0 }}
                      value={value}
                    >
                      <props.caseSamples />
                    </TabPanel>
                  )}
                  {value === "coder_samples" && (
                    <TabPanel
                      sx={{ padding: 0 }}
                      value={value}
                    >
                      <props.caseSamples />
                    </TabPanel>
                  )}
                  {value === "verification_samples" && (
                    <TabPanel
                      sx={{ padding: 0 }}
                      value={value}
                    >
                      <props.caseSamples />
                    </TabPanel>
                  )}
                  {value === "cqa_samples" && (
                    <TabPanel
                        sx={{ padding: 0 }}
                        value={value}
                    >
                        <props.cqaSamples />
                    </TabPanel>
                  )}
                </TabContext>
              )}
            </Box>
          </>
        </Box>
      </>
    </Box>
  );
};
